"use client"

import * as React from "react"
import { Monitor, Moon, Sun } from "lucide-react"
import { useTheme } from "@/components/ui/theme-provider"
import { useEffect, useState } from "react"

import { Button } from "@/components/ui/button"

export function ThemeToggle() {
  const { theme, setTheme } = useTheme()
  const [mounted, setMounted] = useState(false)


  useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) {
    return null
  }

  return (
    <div className="flex items-center justify-between w-full px-2 py-1">
      <Button
        variant={theme === "light" ? "default" : "ghost"}
        size="sm"
        onClick={() => setTheme("light")}
        className="h-8 w-8 p-0"
      >
        <Sun className={`h-4 w-4 ${theme === "light" ? "text-primary-foreground" : "text-muted-foreground"}`} />
        <span className="sr-only">Light theme</span>
      </Button>

      <Button
        variant={theme === "dark" ? "default" : "ghost"}
        size="sm"
        onClick={() => setTheme("dark")}
        className="h-8 w-8 p-0"
      >
        <Moon className={`h-4 w-4 ${theme === "dark" ? "text-primary-foreground" : "text-muted-foreground"}`} />
        <span className="sr-only">Dark theme</span>
      </Button>

      <Button
        variant={theme === "system" ? "default" : "ghost"}
        size="sm"
        onClick={() => setTheme("system")}
        className="h-8 w-8 p-0"
      >
        <Monitor className={`h-4 w-4 ${theme === "system" ? "text-primary-foreground" : "text-muted-foreground"}`} />
        <span className="sr-only">System theme</span>
      </Button>
    </div>
  )
}
